import React, { useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonButton from "components/ArgonButton";
import ArgonInput from "components/ArgonInput";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
// baseUrl
import { baseURL } from "utils/api";
import axios from "utils/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function Index() {
  const [boardName, setBoardName] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!boardName.trim()) {
      toast.error("Board name cannot be empty");
      //   alert("Please enter class name");
      return;
    }
    console.log("New Board Added:", boardName);
    setBoardName(""); // reset input

    axios
      .post(`${baseURL}/boards`, { name: boardName })
      .then((response) => {
        console.log(response.data);
        toast.success(response.data?.message || "Board added successfully");
        // alert("Class added successfully");
        navigate("/curriculum");
      })
      .catch((error) => {
        console.error("Error adding class:", error);
        toast.error(error.response?.data?.error);
        // alert("Failed to add class");
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card sx={{ p: 3, borderRadius: "16px", boxShadow: 3 }}>
            <ArgonTypography mb={1} variant="h5" fontWeight="bold">
              Add Board
            </ArgonTypography>
            <Divider sx={{ mb: 3 }} />

            <form onSubmit={handleSubmit}>
              <ArgonBox display="flex" alignItems="center" gap={2}>
                {/* Input Field */}
                <ArgonBox>
                  <ArgonInput
                    type="text"
                    placeholder="Enter Board Name"
                    value={boardName}
                    onChange={(e) => setBoardName(e.target.value)}
                    sx={{ width: "50%" }}
                  />
                </ArgonBox>
                {/* Button */}
                <ArgonButton
                  color="primary"
                  type="submit"
                  variant="contained"
                  // sx={{ minWidth: "150px", height: "100%" }}
                >
                  Add Board
                </ArgonButton>
              </ArgonBox>
            </form>
          </Card>
        </ArgonBox>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Index;
